import { AxiosResponse } from 'axios';
import { LookUpData } from '../../Model/Dto/LookUpData';
import { PeopleDtos } from '../../Model/Dto/People';
import { ScorecardLink } from '../../Model/Dto/PeopleScorecardLink';
import { SalaryDtos } from '../../Model/Dto/Salaries';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl';
import { Individual } from '../../Model/Dto/Individual';

export const PeopleService = {
    //All people salaries to be removed and replaced with Individual salaries
    SearchPeople: (searchRequest: PeopleDtos.PeopleSearchRequest):
        Promise<AxiosResponse<PeopleDtos.PeopleSearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchPeople, searchRequest),
    GetPeople: (id: number): Promise<AxiosResponse<PeopleDtos.GetPersonRequest>> =>
        axiosCoreInstance.get(ApiUrls.getPeople + id),
    GetPeopleSalariesForYears: (id: number): Promise<AxiosResponse<SalaryDtos.SalariesPerYearResponse[]>> =>
        axiosCoreInstance.get(ApiUrls.getSalariesByPersonIdForYears(id)),
    AddPeopleSalariesForYear: (id: number, year: number): Promise<AxiosResponse<SalaryDtos.SalariesPerYearResponse>> =>
        axiosCoreInstance.post(ApiUrls.addSalariesByPersonIdForYear(id, year)),
    SavePeopleSalariesForYear: (id: number, data: SalaryDtos.SalariesPerYearResponse): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.post(ApiUrls.saveSalariesByPersonIdForYear(id), data),
    DeletePeopleSalariesForYear: (id: number, year: number): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.delete(ApiUrls.deleteSalariesByPersonIdForYear(id, year)),
    GetPersonEmployment: (id: number, onlyActive?: boolean): Promise<AxiosResponse<PeopleDtos.GetPersonEmploymentRequest[]>> =>
        axiosCoreInstance.get(ApiUrls.getPersonEmployment + id + '/' + onlyActive),
    CreatePerson: (person: PeopleDtos.CreatePerson): Promise<AxiosResponse<PeopleDtos.GetPersonRequest>> =>
        axiosCoreInstance.post(ApiUrls.peopleRoot, person),
    UpdatePerson: (person: PeopleDtos.UpdatePerson): Promise<AxiosResponse<PeopleDtos.GetPersonRequest>> =>
        axiosCoreInstance.put(ApiUrls.peopleRoot, person),
    GetPosition: (id: number): Promise<AxiosResponse<PeopleDtos.GetPersonEmploymentRequest>> =>
        axiosCoreInstance.get(ApiUrls.getEmployment + id),
    CreatePosition: (employment: PeopleDtos.GetPersonEmploymentRequest): Promise<AxiosResponse<PeopleDtos.GetPersonEmploymentRequest>> =>
        axiosCoreInstance.post(ApiUrls.createUpdateEmployment, employment),
    UpdatePosition: (employment: PeopleDtos.GetPersonEmploymentRequest): Promise<AxiosResponse<PeopleDtos.GetPersonEmploymentRequest>> =>
        axiosCoreInstance.put(ApiUrls.createUpdateEmployment, employment),
    DeletePerson: (id: number): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.delete(ApiUrls.getPeople + id),
    GetPeopleLookup: (): Promise<AxiosResponse<LookUpData.People[]>> =>
        axiosCoreInstance.get(ApiUrls.getPeopleLookup),
    GetPersonBeforeCreate: (person: PeopleDtos.CheckPerson): Promise<AxiosResponse<PeopleDtos.GetPersonRequest>> =>
        axiosCoreInstance.post(ApiUrls.GetByIdNumberOrEmployeeCode, person),
    GetLatestPositionForPerson: (id: number): Promise<AxiosResponse<PeopleDtos.GetPersonEmploymentRequest>> =>
        axiosCoreInstance.get(ApiUrls.getLatestPositionForPerson + id),
    GetScorecardLinks: (data: ScorecardLink.SearchRequest): Promise<AxiosResponse<ScorecardLink.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.GetScorecardLinks, data),
    GetUnusedPeople: (): Promise<AxiosResponse<number>> =>
        axiosCoreInstance.get(ApiUrls.GetUnusedPeople),
    RemoveUnusedPeople: (): Promise<AxiosResponse> =>
        axiosCoreInstance.delete(ApiUrls.RemoveUnusedPeople),
    //To be removed when Employee Salary is not feature flagged - Moe
    GetPeopleSalariesForYears_Old: (id: number): Promise<AxiosResponse<SalaryDtos.ISalariesPerYearResponse[]>> =>
        axiosCoreInstance.get(ApiUrls.getSalariesByPersonIdForYears(id)),
    AddPeopleSalariesForYear_Old: (id: number, year: number): Promise<AxiosResponse<SalaryDtos.ISalariesPerYearResponse>> =>
        axiosCoreInstance.post(ApiUrls.addSalariesByPersonIdForYear(id, year)),
    SavePeopleSalariesForYear_Old: (id: number, data: SalaryDtos.ISalariesPerYearResponse): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.post(ApiUrls.saveSalariesByPersonIdForYear(id), data),
    //New salary endpoints below
    UpdateSalariesByIndividualIdForYears: (individualId: number, data: SalaryDtos.ISalariesPerYearIndividual): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.put(ApiUrls.UpdateSalariesByIndividualIdForYears(individualId), data),
    GetIndividualSalariesById: (individualId: number): Promise<AxiosResponse<SalaryDtos.ISalariesPerYearIndividual[]>>=>
        axiosCoreInstance.get(ApiUrls.GetIndividualSalariesById(individualId)),
    AddIndividualSalaryForYear: (id: number, year: number): Promise<AxiosResponse<Individual.Salary[]>> =>
        axiosCoreInstance.post(ApiUrls.addSalariesByPersonIdForYear(id, year)),
    UpdateIndividualSalaries: (individualId: number, salaryDates: Individual.SalaryDtoOut[]): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.put(ApiUrls.UpdateIndividualSalaries((individualId)), salaryDates),
};
